export const copilot = {
  name: "Assistant",
  orb: {
    open: "Ask the Assistant",
    hint: "Ask",
    hold: "Hold Space to talk",
  },
  overlay: {
    title: "Assistant",
    placeholder: "Ask, search, or tell me what to do…",
    placeholderContext: "Ask about {{what}}…",
    send: "Ask",
    stop: "Stop",
    close: "Close the Assistant",
    fullscreen: "Open full screen",
    exitFullscreen: "Back to the overlay",
    newSession: "New session",
    sessions: "Sessions",
    noSessions: "Your sessions appear here.",
    deleteSession: "Delete session",
    deleted: "Session deleted",
    hello: "Hi {{name}}. What should we look at?",
    helloHint: "I read your comments, DMs, posts and analytics and show them as live, pinnable views. I can only propose changes: you review and approve every one.",
    disclaimer: "Answers can be wrong. Every change waits for your approval.",
    you: "You",
    error: "The Assistant couldn't finish this answer.",
    retry: "Try again",
    cancelled: "Stopped.",
    loadingSession: "Opening the session…",
    shortcut: "{{key}} J to open · Esc to close",
    thinking: "Thinking…",
  },
  voice: {
    talk: "Talk to the Assistant",
    stop: "Stop listening",
    listening: "Listening… tap the orb when you're done",
    holding: "Listening… release Space to send",
    transcribing: "Understanding…",
    speaking: "Speaking: tap the orb to interrupt",
    noSpeech: "I didn't hear anything. Try again.",
    micDenied: "Microphone access was denied. Allow it in your browser's site settings.",
    mute: "Read answers aloud",
  },
  context: {
    label: "Context",
    page: "this page",
    post: "this post",
    comment: "this comment",
    conversation: "this conversation",
    contact: "this person",
    account: "this account",
    dashboard: "this dashboard",
    job: "this job",
    rule: "this rule",
    publication: "this post",
    selection_one: "{{count}} selected",
    selection_other: "{{count}} selected",
    ignore: "Don't use the page context",
    use: "Use the page context",
  },
  selection: {
    comment_one: "Comments selected: {{count}}",
    comment_other: "Comments selected: {{count}}",
    conversation_one: "Conversations selected: {{count}}",
    conversation_other: "Conversations selected: {{count}}",
    contact_one: "People selected: {{count}}",
    contact_other: "People selected: {{count}}",
    approval_one: "Approvals selected: {{count}}",
    approval_other: "Approvals selected: {{count}}",
    other_one: "Items selected: {{count}}",
    other_other: "Items selected: {{count}}",
    remove: "Remove the selection",
    selectPerson: "Select @{{name}}",
    hint: "Ask about the selected items, e.g. \"hide these\"",
  },
  steps: {
    route: "Understanding the question",
    compose: "Composing the answer",
    repair: "Tidying the answer",
    tool: "Using {{tool}}",
    found_one: "{{count}} found",
    found_other: "{{count}} found",
  },
  tools: {
    search_comments: "Searching comments",
    list_comments: "Listing comments",
    list_deleted: "Finding deleted items",
    get_post: "Opening the post",
    list_posts: "Listing posts",
    post_insights: "Reading post insights",
    account_analytics: "Crunching the numbers",
    best_times: "Finding the best times",
    list_conversations: "Reading conversations",
    get_contact: "Looking up the person",
    list_people: "Ranking commenters",
    list_rules: "Reading rules",
    simulate_rule: "Simulating the rule",
    list_jobs: "Checking jobs",
    sync_health: "Checking sync health",
    search_knowledge: "Searching your knowledge base",
    describe_datasets: "Reading the data catalog",
    calendar_events: "Checking the calendar",
    list_posts_with_comments: "Listing posts with their comments",
    propose_action: "Preparing a proposal",
  },
  blocks: {
    live: "Live",
    snapshot: "Snapshot",
    pin: "Pin to a dashboard",
    pinTo: "Pin to…",
    pinHome: "Home",
    pinNew: "New dashboard",
    pinNewName: "Dashboard name",
    pinNewDefault: "Assistant pins",
    pinCreate: "Create and pin",
    pinned: "Pinned to {{name}}. It stays live.",
    pinOpen: "Open",
    pinFailed: "Couldn't pin this block.",
    comments_one: "{{count}} comment",
    comments_other: "{{count}} comments",
    posts_one: "{{count}} post",
    posts_other: "{{count}} posts",
    conversations_one: "{{count}} conversation",
    conversations_other: "{{count}} conversations",
    showing: "Showing {{shown}} of {{total}}",
    openInbox: "Open in inbox",
    openPerson: "Open profile",
    noData: "Nothing matches right now.",
    loading: "Loading…",
    unread_one: "{{count}} unread",
    unread_other: "{{count}} unread",
    formSubmit: "Send",
    formSent: "Sent",
    timeline: "Timeline",
    job: "Job",
    expand: "Expand",
    collapse: "Collapse",
    postsWithComments_one: "{{count}} post with its comments",
    postsWithComments_other: "{{count}} posts with their comments",
    allComments: "All comments",
    matching: "{{n}} matching",
    noMatching: "No matching comments on this post.",
    showMore: "Show more",
    showLess: "Show less",
    openPost: "Open post",
    peekPost: "Quick look",
    postComments_one: "{{count}} comment",
    postComments_other: "{{count}} comments",
    postLikes_one: "{{count}} like",
    postLikes_other: "{{count}} likes",
    pinnedPair: "Pinned the posts and their comments to {{name}}. They stay live.",
  },
  actions: {
    run: "Run",
    open: "Open",
    filter: "Show",
  },
  proposals: {
    proposal: "Proposal",
    review: "Review",
    reviewTitle: "Review before anything changes",
    items_one: "{{count}} item",
    items_other: "{{count}} items",
    selected_one: "{{count}} of {{total}} selected",
    selected_other: "{{count}} of {{total}} selected",
    selectAll: "Select all",
    selectNone: "Select none",
    include: "Include {{what}}",
    approve_one: "Approve {{count}}",
    approve_other: "Approve {{count}}",
    approveDanger_one: "Delete {{count}} for good",
    approveDanger_other: "Delete {{count}} for good",
    reject: "Reject",
    rejected: "Rejected. Nothing changed.",
    executing: "Working on it…",
    done: "Done",
    summary: "{{ok}} done · {{failed}} failed · {{skipped}} skipped",
    undo: "Undo",
    undone: "Undone",
    undoFailed: "Couldn't undo this.",
    agentNote: "The agent drafts one reply per item. Each draft waits in Approvals: nothing is sent until someone approves it.",
    undoing: "Stopping the job and reverting the items it already changed…",
    undoJob: "Undo job",
    undoToast: "{{title}}: done",
    edit: "Reply text",
    editHint: "You can edit the text before approving.",
    blocked: "Can't be done",
    reversible: "You can undo this for a while after approving.",
    irreversible: "This can't be undone on Instagram.",
    execFailed: "Couldn't run this proposal.",
    expired: "This proposal expired. Ask again.",
    statuses: {
      pending: "Waiting for you",
      executing: "Running",
      executed: "Done",
      partially_executed: "Partly done",
      failed: "Failed",
      rejected: "Rejected",
      expired: "Expired",
      undoing: "Undoing…",
      undone: "Undone",
    },
    kinds: {
      delete_comments: "Delete comments",
      hide_comments: "Hide comments",
      unhide_comments: "Unhide comments",
      reply: "Reply publicly",
      private_reply: "Reply privately",
      send_message: "Send messages",
      flag: "Tag items",
      archive: "Archive comments",
      pin: "Pin comments",
      mark_commenter: "Mark commenters",
      reload_comments: "Reload comments",
      resync_account: "Sync the account",
      create_rule: "Create a rule",
      schedule_post: "Schedule a post",
      agent_reply: "Draft replies with an AI agent",
      assign: "Assign to a teammate",
    },
  },
  suggestions: {
    negativeWeek: "Show negative comments this week",
    spam: "Hide the spam comments",
    bestTime: "When should I post?",
    topPost: "Which post performed best this month?",
    deleted: "Which comments were deleted this week?",
    harmful: "Who are the most harmful commenters?",
    postSpam: "Hide the spam here",
    postSummary: "Summarize the comments on this post",
    postReload: "Reload all comments on this post",
    inboxPrices: "Draft replies for unanswered price questions",
    inboxOpenDms: "Which DMs still have an open 24h window?",
    syncHealth: "Did we miss any live updates?",
    dashboardAdd: "Add a chart of comments by sentiment",
  },
};
